import React from "react";
import styled from "styled-components";
import Arrow from "../../assets/SMSVG/SellerSvg/arrow";
import { baseText } from "../../Lang/fa/BaseText";
import { GetDataPromise } from "../Functions/SendingData";
import { Loading } from "../Loading";
import BlogPost from "./SmallComps/BlogPost";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";


const StyleLaptop = styled.div`
    padding: 2.5rem var(--padding) 0;
    width:  calc(100% - var(--width-padding));
    &.main-grid {
        display: grid;
        grid-template-columns: 6.09% repeat(12, calc(calc(84.7% / 12) - calc(17.16% / 12))) 6.09%;
        grid-column-gap: 1.56%;
        position: relative;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    &.main-grid-inner {
        display: grid;
        grid-template-columns: repeat(12, calc(calc(100% / 12) - calc(17.16% / 12)));
        grid-column-gap: 1.56%;
        position: relative;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .cat-title{
        position: relative;
        width: max-content;
        height: fit-content;
        text-align: right;
        color: var(--text-2);
        font-size: 1.25rem;
        font-weight: 700;
        grid-column: span 2;
        margin: 1rem 0 0.5rem;
    } 
    .main-pad{
        grid-column: span 1;
    }
    .main-box{
        grid-column-start: 2;
        grid-column: span 3;
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        min-height: 20rem;
        color: var(--text-2);
    }
    .container-scroll {
        grid-column: 1/15;
        width: 100%;
        overflow-x: scroll;
        padding: 1rem 0 2rem;
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
    } 
    .main-scroll{
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        position: relative;
        -ms-overflow-style: none; 
        scrollbar-width: none; 
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
        .main-box{
            width: calc(100% - 1rem);
            margin: 0 0.5rem;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            text-decoration: none;
        }
    }
    .arrow{
        cursor: pointer;
        padding:  0.5rem;
        position: absolute;
        border-radius: var(--border-radius-9);
        background-color: var(--body-2);
        border: var(--border-style-2);
        z-index: 1;
        .icon {
            font-size: 2rem;
            display: block;
        }
        &.right {
            top: calc(50% - 1rem);
            right:  calc(var(--padding) - 24px);
        }
        &.left {
            top: calc(50% - 1rem);
            left:  calc(var(--padding) - 24px);
        }
}
   
    @media screen and (max-width: 850px) {
        .main-grid {
            grid-template-columns: 2.22% repeat(4, calc(calc(91.12% / 4) - calc(6.66% / 4))) 2.22%;
            grid-column-gap: 2.22%;
        }
    }
`
const StyleMobile = styled.div`
    display: flex;
    flex-direction: row;
    overflow: hidden;
    justify-content: center;
    padding:0;
    width: 100%; 
    padding: 4rem 0 2rem;
    position: relative;
    &.onecart{
        .main-scroll{
            margin:auto;
        }
        .arrow{
            display: none;
        }
    }
    .cat-title{
        position: absolute;
        top: 1rem;
        right: 1rem;
        width: max-content;
        height: fit-content;
        text-align: right;
        color: var(--text-2);
        font-weight: 700;
        font-size: 1.25rem;
    }
    .main-box{
        grid-column-start: 2;
        grid-column: span 3;
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        min-height: 20rem;
        color: var(--text-2);
    }
    .container-scroll {
        width: 100%;
        overflow-x: scroll;
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
    } 
    .main-scroll{
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        position: relative;
        -ms-overflow-style: none; 
        scrollbar-width: none; 
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
        .main-box{
            width: calc(100% - 1rem);
            margin: 0 0.5rem;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            text-decoration: none;
        }
    }
    .arrow{
        position: absolute;
        display: none;
        align-items: center;
        border: 1px solid var(--n-grey-2);
        padding: 1.5rem 1rem;
        box-shadow: 0px 4px 30px -4px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        background-color: var(--body-2);
        height: 5rem;
        z-index: 2;
        .arr{
            width: 1rem;
        }
    }
    .right{
        right: 0;
        top: 25%;
    }
    .left{
        left: 0;
        top: 25%;
        .arr{
            transform: rotate(-180deg);
        }
    }
`

class RibobonAutoBlogPost extends React.Component{
   constructor(props) {
        super(props);
        this.refScroll = React.createRef()
        this.state={
            postData:props.data.post,
        }
    }
    rightClick=()=>{
        this.refScroll.current.scrollTo({
            left: this.refScroll.current.scrollLeft + (window.innerWidth * 0.80),
            behavior: "smooth"
        })
    }
    leftClick=()=>{
        this.refScroll.current.scrollTo({
            left: this.refScroll.current.scrollLeft - (window.innerWidth * 0.80),
            behavior: "smooth"
        })
    }
    laptopRender(){
        let classname = 'main-grid'
        let pad = <div className="main-pad"></div>
        if(this.props.noPad){
            classname = "main-grid-inner"
            pad = ""
        }
        if(this.state.postData.length > 4) {
            return(
                <StyleLaptop className={classname} >
                    <h2 className="cat-title">{baseText.blog}</h2>
                    {pad}
                    <div className="arrow right" onClick={this.rightClick}><ChevronRight className="icon"/></div>
                    <div className="container-scroll" ref={this.refScroll}>
                        <div className="main-scroll" style={{width: (this.state.postData.length*25) + "%"}}>
                            {this.makeGoods()}
                        </div>
                    </div>
                    <div className="arrow left" onClick={this.leftClick}><ChevronLeft className="icon"/></div>
                    {pad}
                </StyleLaptop>
            )  
        }
        return(
            <StyleLaptop className={classname}>
                <h2 className="cat-title">{baseText.blog}</h2>
                {pad}
                {this.makeGoods()}
                {pad}
            </StyleLaptop>
        )
    }
    makeGoods = () => {
        return this.state.postData.map((v, i) => {
            return (
                <a className="main-box" key={i} href={v.link}>
                    <BlogPost data={v} />
                </a>
            )
        })
    }
    mobileRender(){
        return(
            <StyleMobile className={(this.state.postData.length === 1 ? 'onecart' : '')}>
                <span className="cat-title">{baseText.blog}</span>
                <div className="arrow right"><Arrow click={this.rightClick}/></div>
                <div className="container-scroll" ref={this.refScroll}>
                    <div className="main-scroll" style={{width: (this.state.postData.length*80) + "vw"}}>
                        {this.makeGoods()}
                    </div>
                </div>
                <div className="arrow left"><Arrow click={this.leftClick}/></div>
            </StyleMobile>
        )
    }
    render(){
        if(this.state.postData && this.state.postData.length > 0){
            if(window.innerWidth < 850 ){
                return this.mobileRender()
            }else{
                return this.laptopRender()
            }
        }
        return "";
        // return <Loading/>
    }
}
export default RibobonAutoBlogPost